import React from 'react'
import { useSelector } from 'react-redux'
import {
  selectIsUserConnected,
  selectIsUserKnown,
  selectIsUserNotConnected
} from '../../../store/userAccount/userAccount.selectors'

/* eslint-disable react/display-name */
export const withUserConnected = Component => props => {
  if (__SERVER__) return <></>

  const isConnected = useSelector(selectIsUserConnected)

  return isConnected ? <Component {...props} /> : null
}

/* eslint-disable react/display-name */
export const withUserNotConnected = Component => props => {
  if (__SERVER__) return <></>

  const isNotConnected = useSelector(selectIsUserNotConnected)

  return isNotConnected ? <Component {...props} /> : null
}

export const withUserKnown = Component => props => {
  if (__SERVER__) return <></>

  const isKnown = useSelector(selectIsUserKnown)

  return isKnown ? <Component {...props} /> : null
}

export const withUserUnknown = Component => props => {
  if (__SERVER__) return <></>

  const isKnown = useSelector(selectIsUserKnown)

  return !isKnown ? <Component {...props} /> : null
}
